import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { ConfigurationsResultsResponse } from '../../../models/configurations/responses/api-configurations-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiConfigurationsService {

  constructor(private apiService: ApiService) { }

  getServerConfigurations(): Promise<ConfigurationsResultsResponse> {
    return new Promise<ConfigurationsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.configurationsGetServerConfigurationsUrl, ConfigurationsResultsResponse).then(
        (data: ConfigurationsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getClientConfigurations(): Promise<ConfigurationsResultsResponse> {
    return new Promise<ConfigurationsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.configurationsGetClientConfigurationsUrl, ConfigurationsResultsResponse).then(
        (data: ConfigurationsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getConfigurations(configurationsNames: string[]): Promise<ConfigurationsResultsResponse> {
    return new Promise<ConfigurationsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.configurationsGetConfigurationsUrl, {
        configurations_names: configurationsNames
      }, ConfigurationsResultsResponse).then(
        (data: ConfigurationsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  editConfiguration(name: string, valueText: string, valueInteger: number, applicationId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.configurationsEditConfigurationUrl, {
        name,
        value_text: valueText,
        value_integer: valueInteger,
        application_id: applicationId
      }).then(() => { resolve(); }, error => { reject(error); });
    });
  }

  deleteConfiguration(name: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.configurationsDeleteConfigurationUrl, { name }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteApplicationConfiguration(name: string, applicationId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.configurationsDeleteApplicationConfigurationUrl, {
        name,
        application_id: applicationId
      }).then(() => { resolve(); }, error => { reject(error); });
    });
  }
}
